import { MODULE_ALIASES } from './constants';
export function parseDeepLinkFromURL(searchParams) {
    const moduleParam = searchParams.get('module');
    if (!moduleParam) {
        console.warn('[DeepLink Parser] Missing required "module" parameter');
        return null;
    }
    const module = normalizeModule(moduleParam);
    if (!module) {
        console.warn('[DeepLink Parser] Unknown module:', moduleParam);
        return null;
    }
    const params = {};
    searchParams.forEach((value, key) => {
        if (key !== 'module') {
            params[key] = value;
        }
    });
    console.log('[DeepLink Parser] Parsed successfully:', { module, params });
    return {
        module,
        params,
        timestamp: Date.now(),
    };
}
function normalizeModule(value) {
    const normalized = value.toLowerCase().trim();
    return MODULE_ALIASES[normalized] ?? null;
}
